<mat-toolbar color="primary" class="toolbar">
    <app-back-button [route]="['/home', 'perfil']" color="secondary"></app-back-button>
    <div>{{ "SETTINGS.TITLE" | translate }}</div>
</mat-toolbar>

<mat-card>
    <mat-card-content>
        <button
            [id]="'button_profile-preferences_EditarSalvar'"
            mat-mini-fab
            color="primary"
            (click)="toggleEdition()"
            class="edition-button"
        >
            <mat-icon aria-label="label">{{ editMode ? "save" : "create" }}</mat-icon>
        </button>

        <div class="form-container">
            <mat-form-field style="width: 100%">
                <mat-label>{{ "SETTINGS.LANG" | translate }}</mat-label>
                <mat-select [(ngModel)]="cardData.idioma" [disabled]="!editMode">
                    <mat-option value="pt-BR">Português (Brasil)</mat-option>
                    <mat-option value="en-US">English (United States)</mat-option>
                    <mat-option value="es-ES">Español (España)</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-slide-toggle color="primary" [(ngModel)]="cardData.mostrarEmail" [disabled]="!editMode">
                {{ getShowEmailText() | translate }}
            </mat-slide-toggle>

            <mat-slide-toggle color="primary" [(ngModel)]="cardData.deixarCursosVisiveis" [disabled]="!editMode">
                {{ getShowCoursesText() | translate }}
            </mat-slide-toggle>
        </div>
    </mat-card-content>
</mat-card>

<app-overlay-spinner [show]="loading$ | async"></app-overlay-spinner>
